import React, { FC } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { QRCodeCanvas } from 'qrcode.react';
import { CredentialOffer } from './credentialOffers';

export interface RowState {
    loading: boolean;
    oidcUrl?: string;
    visible: boolean;
    error?: string;
}

interface Props {
    offer: CredentialOffer;
    state: RowState;
    onToggle: (templateId: string) => void;
}

export const CredentialRow: FC<Props> = ({offer, state, onToggle}) => {
    const showQr = state.visible && !!state.oidcUrl;

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            padding: '18px',
            border: '1px solid #e2e3ee',
            borderRadius: '14px',
            marginBottom: '16px',
            backgroundColor: '#fff',
        }}>
            <Box
                component="img"
                src={offer.imageUrl}
                alt={offer.title}
                sx={{width: '230px', height: '144px', borderRadius: '12px', objectFit: 'cover', flex: 'none'}}
            />
            <Box sx={{flex: 1}}>
                <Typography sx={{fontSize: '16px', fontWeight: 600, color: '#1c1c1c', marginBottom: '6px'}}>
                    {offer.title}
                </Typography>
                <Typography sx={{fontSize: '13px', color: '#666'}}>
                    {offer.description}
                </Typography>
                {state.error ? (
                    <Typography sx={{fontSize: '12px', color: '#d32f2f', marginTop: '8px'}}>
                        {state.error}
                    </Typography>
                ) : null}
            </Box>
            <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px'}}>
                {showQr ? (
                    <Box data-testid={`qr-${offer.templateId}`}>
                        <QRCodeCanvas value={state.oidcUrl!} size={180}/>
                    </Box>
                ) : null}
                <Button
                    variant={showQr ? 'outlined' : 'contained'}
                    disabled={state.loading}
                    onClick={() => onToggle(offer.templateId)}
                    sx={{textTransform: 'unset', minWidth: '140px'}}
                >
                    {state.loading ? <CircularProgress size={20}/> : showQr ? 'Hide' : 'Add to wallet'}
                </Button>
            </Box>
        </Box>
    );
};
